import React from 'react';

const OrderNumberInput = ({ filter, onChangeYear, onChangeMonth, onChangeOrderNumber, margin, hideLabel=false }) => (
  <div className={`column ${margin ? margin : 'is-one-fifth'}`}>
    <div className="field">
      {!hideLabel && <label className="label is-normal">Número de Órden</label>}
      <div className="field-body">
        <div className="field">
          <p className="control is-expanded">
            <input className="input" type="number" placeholder="Año" onChange={onChangeYear} value={filter.year} />
          </p>
        </div>
        <div className="field">
          <p className="control is-expanded">
            <input className="input" type="number" placeholder="Mes" onChange={onChangeMonth} value={filter.month} />
          </p>
        </div>
        <div className="field">
          <p className="control is-expanded">
            <input className="input" type="number" placeholder="Número de Órden" onChange={onChangeOrderNumber} value={filter.orderNumber} />
          </p>
        </div>
      </div>
    </div>
  </div>
)

export default OrderNumberInput;